define('form/completer',['jquery', 'require', 'lib/string_score', 'utils/common', 'jqueryui/widgets/autocomplete'], function ($, require) {
	
	/**
	 * AutoCompleter
	 * Haalt allerlei stuff op van source en handelt de data daarmee af
	 * 
	 * options:
	 * 	function: onChoice Callback when a options is chosen
	 * 	function: onEnter Callback when a option is chosen (can either be enter of choice)
	 * 	int: max_results Max result to list
	 * 	Source: source 
	 * 	bool: directShow Direct show a list when focus on input
	 * 
	 */
	var Completer = function (input, options) {
		$this = this;
		var defaults = $.extend({
			onChoice : function (item) {},
			onEnter : function (label) {},
			
			max_results : 10,
			
			source : null,
			
			directShow : true,
			
			score : null
		}, options);
		
		this.options = defaults;
		
		this.input = $(input);
		this.currentTerm = '';
		
		this.init();
	};
	
	Completer.prototype.reset = function () {
		this.currentTerm = '';
		this.input.val('');
		if(this.input.autocomplete != undefined)
			this.input.autocomplete("close");
	};
	
	Completer.prototype.score = function (a, b) {
		if(this.options.score == null) {
			return a.score(b, 0.3);			
		} else {
			return this.options.score(a, b);	
		}
	};
	
	/**
	 * Filter the matched content
	 * @param array
	 * @param term
	 * @returns filtered array
	 */
	Completer.prototype.filter = function (array, term) {
		var $this = this;
		var source = $this.options.source;
		
		term = term.toLowerCase();
		
		var scored_array = $.map(array, function (item) {
			var str = source.getLabel(item).toString().toLowerCase();
			
			var sc = $this.score(str, term);;
			if(item.name == null) {
				item.score = 0;
			} else {
				item.score = sc;
			}
			
			return item;
		});
		
		scored_array.sort(function (a, b) {
			if(a.score == b.score) return 0;
			return a.score < b.score ? 1 : -1;
		});
		
		var a = scored_array.slice(0, this.options.max_results);

		return a;
		
	};
	
	/**
	 * Init completer and its events e.d.
	 */
	Completer.prototype.init = function () {
		if(!this.input.exists()) return;
		
		var $this = this;
		var source = this.options.source;
		
		// om de enter die form submit te preventen
		this.input.keydown(function (e) {
			if(e.keyCode == 13) { e.preventDefault(); return false; }
		});
		
		this.input.keyup(function (e) {
			if(e.keyCode == 13) {
				$this.options.onEnter($this.input.val());
			}
		});
		
		// focus in en out for nice look
		this.input.focusin(function () {
			$(this).parent('.multiselect').addClass("focus");
		});
		this.input.focusout(function () {
			$(this).parent('.multiselect').removeClass("focus");
		});
		
		this.input.parent('.multiselect').click(function(){
			$(this).find('.ui-autocomplete-input').focus();
		});
		
		// init autocomplete
		autoc = this.input.autocomplete({
			minLength : 0,
			delay : 0,
			source : function (request, response) {
				$this.currentTerm = request.term;
				
				source.retrieve(function (result) {
					response($this.filter(result, request.term));
				}, {q : request.term});
			},
			
			select : function (event, ui) {
				event.preventDefault();
				$this.options.onChoice(ui.item);
				return false;
			},
			
			focus: function(event, ui) {
				$this.input.val($this.options.source.getLabel(ui.item));
				return false;
			}
		}).data('ui-autocomplete');
		
		// RENDER OVERWRITE
		autoc._renderItem = function(ul, item) {
			var f = source.getFormatter();
			
			item.name = item.name.htmlspecialchars();
			
			return f(item, $this.currentTerm)
			.data("ui-autocomplete-item", item)
			.appendTo(ul);
		};
		
		// Kopie van de source, overschreven, ergens gaat er iets fout met een race condition...
		// Weggehaald en mijn code werkt fantastisch :)
		autoc._response = function() {
			var that = this;
			
			return function( content ) {
				that.__response( content );
		
				that.pending--;
				if (!that.pending) 
					that.element.removeClass( "ui-autocomplete-loading" );
				
			}; 
		};
		
		if(this.options.directShow) {
			this.input.focus(function (e) {
				if($(this).val() == "")
					$this.input.autocomplete("search", " ");
			});
		}
	};
	
	// jquery variant 
	$.fn.completer = function (global_settings) {
		return this.each(function () {
			var el = $(this);
			var c = new Completer(el, global_settings);
			el.data('completer', c);
			return el;
		});
	};
	
	return Completer;
});
